module.exports = __webpack_public_path__ + "static/4_2_recommendation_IT-c35bae5a21325ab190732e57135d6e61.svg";